import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// COMPONENTS
import { SwiperCarousel } from '@/components/Carousels/SwiperCarousel';

// STYLES
import { Wrapper } from './styles';

const StageCarousel = props => {
  const { children, className, carouselOptions, stylesType } = props;

  return (
    <Wrapper className={clsx('stage-carousel', className, stylesType)}>
      <SwiperCarousel options={carouselOptions}>{children}</SwiperCarousel>
    </Wrapper>
  );
};

StageCarousel.defaultProps = {
  className: '',
  carouselOptions: {},
  stylesType: 'default',
};

StageCarousel.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  carouselOptions: PropTypes.object,
  stylesType: PropTypes.string, // default | where-to-watch | want-to-watch | collections
};

export default React.memo(StageCarousel);
